import { render, staticRenderFns } from "./VendorFilesPage.vue?vue&type=template&id=0490a21b&scoped=true&"
import script from "./VendorFilesPage.vue?vue&type=script&lang=js&"
export * from "./VendorFilesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490a21b",
  null
  
)

export default component.exports